import './index.scss'
// import '../../assets/scripts/myNiceScroll'
// import {resizeScroll} from '../../assets/scripts/myNiceScroll'
import Swiper from 'swiper/swiper-bundle.min.js'

var swiper = new Swiper(".section1 .mySwiper", {
  speed: 600,
  autoplay: { // 自动切换
    delay: 3000,
    stopOnLastSlide: false,
    disableOnInteraction: false,
  },
  on:{
    init: function(swiper){
      $('.section1 .common-news-swiper .swiper-tab li').eq(0).addClass('active')
    },
    slideChangeTransitionStart: function(){
      $('.section1 .common-news-swiper .swiper-tab li').eq(this.realIndex).addClass('active').siblings().removeClass('active')
    },
  },
})

$('.section1 .common-news-swiper .swiper-tab li').hover(function(){
  let index = $(this).index()
  swiper.slideTo(index)
})